import React from 'react';

import { Flex, Select, SelectProps } from 'antd';

import { DeactivatedTag } from '@components/warehouses';

import { useWarehouseQuery } from './hooks/useWarehouseQuery';

interface IProps extends SelectProps {
  placeholder: string;
}

export const WarehouseSelect: React.FC<IProps> = ({ placeholder, ...props }) => {
  const { data, hasNextPage, fetchNextPage } = useWarehouseQuery({
    limit: 10,
  });

  const dataSource = data?.pages?.map((data) => data.items || []).flat() || [];

  return (
    <Select
      labelInValue
      placeholder={placeholder}
      style={{ minWidth: '200px' }}
      onPopupScroll={(e) => {
        e.persist();
        const target = e.currentTarget;
        if (target?.scrollTop + target?.offsetHeight === target?.scrollHeight && hasNextPage) {
          fetchNextPage();
        }
      }}
      notFoundContent={null}
      options={dataSource?.map((el) => ({
        data: el,
        label: el.name,
        value: el.uid,
      }))}
      optionRender={(option) => (
        <Flex gap={8} align="center" wrap>
          {option.label}
          <DeactivatedTag deactivatedAt={option.data.data.deactivated_at} />
        </Flex>
      )}
      {...props}
    />
  );
};
